import { render, staticRenderFns } from "./remitData.vue?vue&type=template&id=c19124ae&scoped=true"
import script from "./remitData.vue?vue&type=script&lang=js"
export * from "./remitData.vue?vue&type=script&lang=js"
import style0 from "./remitData.vue?vue&type=style&index=0&id=c19124ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19124ae",
  null
  
)

export default component.exports